import { render, staticRenderFns } from "./VehicleTypeSelect.vue?vue&type=template&id=aae0972a&lang=pug"
import script from "./VehicleTypeSelect.vue?vue&type=script&lang=js"
export * from "./VehicleTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports